import { useCallback, useEffect } from "react"
import { postSubmit } from "@ui-seeker/utils"
import { TIME_OUT_STATUS, STATUS_START_DELAY } from "@constants"
import { reportListCellData, reportListStatus, setReportData } from "../@signals"
import { useReportBackendApiPath } from "Pages/ReportsAlerts/Reports/@hooks/index"
import { batch } from "@preact/signals-react"

export default function useManageStatusMultiple() {
	const { multipleStatus } = useReportBackendApiPath()
	const getStatus = useCallback(() => {
		let isMounted = true
		const fetchStatus = () => {
			if (document.hidden) {
				// a background tab keeps its timer but sends nothing; it catches up when shown again
				setTimeout(() => {
					if (isMounted) fetchStatus()
				}, TIME_OUT_STATUS)
				return
			}
			if (!!reportListStatus.value.length) {
				postSubmit(multipleStatus, {
					executions: reportListStatus.value.map(idReport => idReport),
				}).then((res) => {
					if (!isMounted) return
					const filteredIds = Object.values(res)
						.filter(item => !item?.ExecutionGlobalStatusCompleted)
						.map(item => item?.idReportExecution)

					if (filteredIds.length !== reportListStatus.value.length) {
						reportListStatus.value = filteredIds
					}
					if (Object.values(res).some(({ ExecutionGlobalStatusCompleted }) => ExecutionGlobalStatusCompleted)) {
						batch(() => {
							Object.values(res).map(report => {
								if (report.ExecutionGlobalStatusCompleted) {
									setReportData(report)
								}
							})
						})
					}

					reportListCellData.value = {
						...reportListCellData.value,
						...res
					}

					if (Object.keys(res).some(key => !res[key].ExecutionGlobalStatusCompleted)) {
						setTimeout(() => {
							if (isMounted) fetchStatus()
						}, TIME_OUT_STATUS)
					}
				})
			}
		}

		fetchStatus()

		return () => {
			isMounted = false
		}
	}, [reportListStatus.value.length])

	useEffect(() => {
		// getStatus is recreated for every row that registers on mount: without the delay each one
		// restarted the poll and fired a POST, N of them for N running rows
		let stop
		const timer = setTimeout(() => { stop = getStatus() }, STATUS_START_DELAY)
		return () => {
			clearTimeout(timer)
			if (stop) stop()
		}
	}, [getStatus])

}
